import { render, staticRenderFns } from "./CameraBoxOld.vue?vue&type=template&id=6d8ec385&scoped=true&"
import script from "./CameraBoxOld.vue?vue&type=script&lang=js&"
export * from "./CameraBoxOld.vue?vue&type=script&lang=js&"
import style0 from "./CameraBoxOld.vue?vue&type=style&index=0&id=6d8ec385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ec385",
  null
  
)

export default component.exports